import React from 'react';
import { Link } from 'react-router-dom';
import './LinkButton.scss'; // Import CSS for styling

interface LinkButtonProps {
  label: string;
  link: string;
}

const LinkButton: React.FC<LinkButtonProps> = ({ label, link }) => (
  <Link to={link} className="link-button">
    {label}
  </Link>
);

export default LinkButton;
